import DefineDocumentPreview from './define-document-preview.view';

export default DefineDocumentPreview;
